// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2hpI4","uploadButton":"styles_uploadButton__32Zni"};